// extracted by mini-css-extract-plugin
export default {"restrictedUpload":"LockedFiles_restrictedUpload__n+jkY","attachments":"LockedFiles_attachments__qpMxQ"};